export const AMO_OPTIONS = [
    ["", "—"],
    ["NOT_PROVIDED", "-"],
    ["OK", "OK"],
    ["NO", "Non"],
    ["DECEASED", "DCD"],
    ["DEPARTED", "Départ"],
];

export const GUARDIAN_OPTIONS = [
    ["", "—"],
    ["NONE", "Aucun"],
    ["COMPLETE", "Complet"],
    ["EMAIL", "Email"],
    ["EMAIL_ADDRESS", "Email / Adresse"],
];

export const BOOLEAN_OPTIONS = [["", "—"], ["true", "Oui"], ["false", "Non"]];

export const PATIENT_STATUS_OPTIONS = [["AUCUN", "Aucun"], ["DCD", "DCD"], ["HOSPITALISATION", "Hospitalisation"], ["DEPART", "Départ"]];

export const PATIENT_STATUS_LABELS = Object.fromEntries(PATIENT_STATUS_OPTIONS);

export const CREDIT_AUTHORIZATION_NOT_PROVIDED = "Non renseigné";

export const CREDIT_AUTHORIZATION_REFUSED = "Refus";

export const CREDIT_AUTHORIZATION_OPTIONS = [[CREDIT_AUTHORIZATION_NOT_PROVIDED, "Non renseigné"], ["Oui", "Oui"], [CREDIT_AUTHORIZATION_REFUSED, "Refus"]];

export const AMC_SCAN_NOT_PROVIDED = "Non renseigné";

export const AMC_SCAN_OPTIONS = [[AMC_SCAN_NOT_PROVIDED, "Non renseigné"], ["Oui", "Oui"], ["Non", "Non"]];

export const ADMIN_API_CONFIG = {};

export const WITHOUT_SUBCATEGORY_FILTER = "__WITHOUT_SUBCATEGORY__";

export const RESIDENT_STATUS_FILTERS = [
    ["all", "Tous"],
    ["active", "Actifs"],
    ["inactive", "Inactifs"],
];

export const PATIENT_PAGE_SIZE = 25;

export const MAX_IMPORT_FILES = 1000;

export const GUARDIAN_CURATOR_FIELDS = [
    ["patientName", "PATIENT"],
    ["creditAuthorization", "AUTORISATION CRÉDIT"],
    ["amo", "A.M.O"],
    ["amc", "A.M.C"],
    ["amcScan", "SCAN A.M.C"],
    ["credit", "CREDIT"],
    ["guardianContact", "CONTACT TUTEUR"],
    ["resdt", "RESDT"],
    ["invoiceSentOrUpdated", "ENVOI FACTURE / MIS A JOUR"],
    ["remarks", "REMARQUES"],
];

export const EDITABLE_FIELDS = [
    "version", "nom", "prenom", "dateNaissance", "chambre", "productionSubcategory", "patientStatus", "nir", "inactive", "notInvoiced",
    "creditAuthorizationType", "creditAuthorizationAmount", "creditAuthorization", "amoStatus",
    "amcDate", "amcScanReceived", "scanAuto", "creditNote", "guardianContactStatus", "guardianContactValue",
    "guardianSentDate", "correspondingPharmacistDeclaration", "administrativeRemarks",
    "admissionAssessmentDate", "admissionInterviewDate", "admissionInterviewNote", "admissionMembershipDate",
    "pdaProductionRemark", "antalgique", "bpmInitialInterview", "bpmYear1TreatmentAnalysis",
    "bpmYear1FollowUpInterview", "bpmYear1ObservanceInterview", "insulin", "authorizedInvoiceCount", "zopiclone",
    "expensiveProducts", "chronicLastBillingDate", "billingRemarks", "toInvoice",
];

export const MERGEABLE_FIELDS = EDITABLE_FIELDS.filter(field => field !== "version");

export const BPM_LABELS = {
    bpmInitialInterview: "BPM ENTRETIEN INITIALE (BMI) 15 €",
    bpmYear1TreatmentAnalysis: "BPM Année 1 Analyse du traitement (BMI) (+1 mois) 15 €",
    bpmYear1FollowUpInterview: "BPM Année 1 Entretien de suivi (BMI) (+3 mois) 15 €",
    bpmYear1ObservanceInterview: "BPM Année 1 Entretien observance (BMI) (+3 mois) 20 €",
};

export const FIELD_LABELS = {
    nom: "Nom",
    prenom: "Prénom",
    dateNaissance: "Date de naissance",
    chambre: "Chambre",
    productionSubcategory: "Sous-catégorie",
    patientStatus: "Statut patient",
    nir: "NIR",
    inactive: "Résident inactif",
    notInvoiced: "Ne pas facturer",
    creditAuthorizationType: "Type d’autorisation de crédit",
    creditAuthorizationAmount: "Montant autorisé",
    creditAuthorization: "Autorisation crédit",
    amoStatus: "A.M.O",
    amcDate: "Date A.M.C",
    amcScanReceived: "Scan A.M.C",
    scanAuto: "Scan auto",
    creditNote: "Crédit",
    guardianContactStatus: "Contact tuteur",
    guardianContactValue: "Coordonnée tuteur",
    guardianSentDate: "Date d’envoi au tuteur",
    correspondingPharmacistDeclaration: "Déclaration pharmacien correspondant",
    administrativeRemarks: "Remarques administratives",
    admissionAssessmentDate: "Date du bilan",
    admissionInterviewDate: "Date de l’entretien",
    admissionInterviewNote: "Commentaire entretien",
    admissionMembershipDate: "Date d’adhésion",
    pdaProductionRemark: "Remarque production",
    antalgique: "Antalgique",
    bpmInitialInterview: BPM_LABELS.bpmInitialInterview,
    bpmYear1TreatmentAnalysis: BPM_LABELS.bpmYear1TreatmentAnalysis,
    bpmYear1FollowUpInterview: BPM_LABELS.bpmYear1FollowUpInterview,
    bpmYear1ObservanceInterview: BPM_LABELS.bpmYear1ObservanceInterview,
    insulin: "Insuline",
    authorizedInvoiceCount: "Nombre de factures autorisé",
    zopiclone: "Zopiclone",
    expensiveProducts: "Produits chers",
    chronicLastBillingDate: "Dernière facturation chronique",
    billingRemarks: "Remarque facturation",
    toInvoice: "À facturer",
};

export const PROPOSAL_FIELD_LABELS = {
    credit_authorization: FIELD_LABELS.creditAuthorization,
    credit_authorization_type: FIELD_LABELS.creditAuthorizationType,
    credit_authorization_amount: FIELD_LABELS.creditAuthorizationAmount,
    credit_note: FIELD_LABELS.creditNote,
    amo_status: FIELD_LABELS.amoStatus,
    amc_date: FIELD_LABELS.amcDate,
    amc_scan_received: FIELD_LABELS.amcScanReceived,
    scan_auto: FIELD_LABELS.scanAuto,
    guardian_contact_status: FIELD_LABELS.guardianContactStatus,
    guardian_contact_value: FIELD_LABELS.guardianContactValue,
    corresponding_pharmacist_declaration: FIELD_LABELS.correspondingPharmacistDeclaration,
    nir: FIELD_LABELS.nir,
};

export const EVENT_LABELS = {
    INSULIN: "Facturations insuline",
    ZOPICLONE: "Facturations Zopiclone",
    EXPENSIVE_PRODUCT: "Facturations produits chers",
    CHRONIC: "Facturations chroniques",
    FLU: "Vaccinations grippe",
    COVID: "Vaccinations Covid",
};

export const TABLE_SECTIONS = {
    administration: { header: "#0f766e", subHeader: "#ccfbf1", cell: "#f0fdfa", border: "#99f6e4" },
    admission: { header: "#7c3aed", subHeader: "#ede9fe", cell: "#f5f3ff", border: "#ddd6fe" },
    bpm: { header: "#9333ea", subHeader: "#f3e8ff", cell: "#faf5ff", border: "#e9d5ff" },
    pda: { header: "#2563eb", subHeader: "#dbeafe", cell: "#eff6ff", border: "#bfdbfe" },
    insulin: { header: "#ea580c", subHeader: "#ffedd5", cell: "#fff7ed", border: "#fed7aa" },
    zopiclone: { header: "#be123c", subHeader: "#ffe4e6", cell: "#fff1f2", border: "#fecdd3" },
    expensiveProducts: { header: "#ca8a04", subHeader: "#fef3c7", cell: "#fffbeb", border: "#fde68a" },
    chronic: { header: "#4f46e5", subHeader: "#e0e7ff", cell: "#eef2ff", border: "#c7d2fe" },
    billingRemarks: { header: "#334155", subHeader: "#e2e8f0", cell: "#f8fafc", border: "#cbd5e1" },
    toInvoice: { header: "#15803d", subHeader: "#dcfce7", cell: "#f0fdf4", border: "#bbf7d0" },
};

export const SUB_COLUMNS = [
    ["Autorisation crédit", "administration"],
    ["Montant autorisation crédit", "administration"],
    ["Crédit", "administration"],
    ["AMO", "administration"],
    ["Scan AMC", "administration"],
    ["AMC", "administration"],
    ["Autorisation prélèvement auto", "administration"],
    ["Contact tuteur", "administration"],
    ["Date d’envoi", "administration"],
    ["Déclaration pharmacien", "administration"],
    ["Remarques administratives", "administration"],
    ["Bilan", "admission"],
    ["Entretien", "admission"],
    ["Commentaire entretien", "admission"],
    ["Adhésion", "admission"],
    [BPM_LABELS.bpmInitialInterview, "bpm"],
    [BPM_LABELS.bpmYear1TreatmentAnalysis, "bpm"],
    [BPM_LABELS.bpmYear1FollowUpInterview, "bpm"],
    [BPM_LABELS.bpmYear1ObservanceInterview, "bpm"],
    ["Vaccin grippe", "admission"],
    ["Vaccin Covid", "admission"],
    ["Remarque production", "pda"],
    ["Antalgique", "pda"],
    ["Oui / Non", "insulin"],
    ["Nb factures autorisé", "insulin"],
    ["Dates facturation", "insulin"],
    ["Oui / Non", "zopiclone"],
    ["Dernière facturation", "zopiclone"],
    ["Produit(s)", "expensiveProducts"],
    ["Dates facturation", "expensiveProducts"],
    ["Date de dernière facturation", "chronic"],
];

export const HORIZONTAL_TABLE_COLUMN_COUNT = 1 + SUB_COLUMNS.length + 3;
